import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { timeline, TimelineTypes } from 'api';
import CommentCreateForm from './CommentCreateForm';
import CommentsList from './CommentsList';
import CommentsLoadingList from './CommentsLoadingList';

interface Props {
  id: string;
  type: TimelineTypes.ModelEnum;
  commentType?: TimelineTypes.ItemCreateParams['comment_type'];
  commentsHeight?: string;
}

const Timeline = (props: Props): JSX.Element | null => {
  const { id, type, commentType, commentsHeight } = props;

  const { data, error, refetch } = useQuery(
    [timeline.endpoints.getList(type, id), type, id],
    () => timeline.getList(type, id),
  );

  return (
    <Card>
      <CardContent>
        <Stack>
          <CommentCreateForm
            id={id}
            type={type}
            refetch={refetch}
            commentType={commentType}
          />
          {error ? (
            <Box py={3}>
              <Typography variant="subtitle2" color="error">
                Failed to load timeline data
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{
                height: commentsHeight || 'calc(100vh - 480px)',
                overflow: 'auto',
              }}
            >
              {!data ? (
                <CommentsLoadingList />
              ) : (
                <CommentsList
                  id={id}
                  type={type}
                  data={data}
                  refetch={refetch}
                />
              )}
            </Box>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default Timeline;
